import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store.js'
import createClient from './views/create-client'
import createSegment from './views/create-segment'
import listSegment from './views/list-segment'
import createMailing from './views/create-mailing'
import editMailing from "./views/editMailing";
import Login from './views/auth/login.vue'
import listMailing from './views/list-mailing'
import listTrigger from './views/list-trigger'
import createTrigger from './views/create-trigger'
import createTriggerMailing from './views/create-trigger-mailing'
import listTriggerMailing from './views/list-trigger-mailing'
import historyTriggerMessage from './views/history-trigger-message'
import createGroupManager from './views/create-group-manager'
import listGroupManager from './views/list-group-manager'
import viewGroupManager from './views/view-group-manager'
import createBot from './views/create-bot'
import analytics from './views/analytics'
import viewChat from './views/chat'
import finance from './views/finance'
import pageNotFound from './views/page-not-found'
import historyPay from './views/history-pay'
import Clients from './views/clients'
import branchBot from './views/branch-bot'
import settings from './views/profile/settings'
import viewSegment from './views/segment/view-segment'
import register from './views/auth/register'
import requests from './views/bot/requests'
import viewRequest from './views/bot/view-request'
import statisticsBranch from './views/analytics/statistics-branch'
import statisticsTrigger from './views/analytics/statistics-trigger'
import statisticsFollow from './views/analytics/statistics-follow'
import statisticsUrl from './views/analytics/statistics-url'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/clients'
    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        layout: 'empty',
        requiresAuth: false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        layout: 'empty',
        requiresAuth: false
      }
    },
    {
      path: '/create-client',
      name: 'create-client',
      component: createClient,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/create-segment',
      name: 'create-segment',
      component: createSegment,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/list-segment',
      name: 'list-segment',
      component: listSegment,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/view-segment/:id',
      name: 'view-segment',
      component: viewSegment,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/create-mailing/:id?',
      name: 'create-mailing',
      component: createMailing,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/edit-mailing/:id',
      name: 'edit-mailing',
      component: editMailing,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/list-mailing',
      name: 'list-mailing',
      component: listMailing,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/list-trigger',
      name: 'list-trigger',
      component: listTrigger,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/create-trigger',
      name: 'create-trigger',
      component: createTrigger,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/create-trigger-mailing',
      name: 'create-trigger-mailing',
      component: createTriggerMailing,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/list-trigger-mailing',
      name: 'list-trigger-mailing',
      component: listTriggerMailing,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/history-trigger-message/:id',
      name: 'history-trigger-message',
      component: historyTriggerMessage,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/create-group-manager',
      name: 'create-group-manager',
      component: createGroupManager,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/list-group-manager',
      name: 'list-group-manager',
      component: listGroupManager,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/requests',
      name: 'requests',
      component: requests,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/view-request/:id',
      name: 'view-request',
      component: viewRequest,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/view-group-manager/:id',
      name: 'view-group-manager',
      component: viewGroupManager,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/create-bot',
      name: 'create-bot',
      component: createBot,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/branch-bot',
      name: 'branch-bot',
      component: branchBot,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: analytics,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/statistics-branch',
      name: 'statistics-branch',
      component: statisticsBranch,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/statistics-trigger',
      name: 'statistics-trigger',
      component: statisticsTrigger,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/statistics-follow',
      name: 'statistics-follow',
      component: statisticsFollow,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/statistics-url',
      name: 'statistics-url',
      component: statisticsUrl,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/view-chat',
      name: 'view-chat',
      component: viewChat,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/finance',
      name: 'finance',
      component: finance,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/history-pay',
      name: 'history-pay',
      component: historyPay,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/profile/settings/:token?',
      name: 'settings',
      component: settings,
      props: true,
      meta: {
        layout: 'main',
        requiresAuth: true
      }
    },
    {
      path: '/page-not-found',
      name: 'page-not-found',
      component: pageNotFound,
      meta: {
        layout: 'empty',
        requiresAuth: false
      }
    },
    {
      path: '*',
      redirect: '/page-not-found'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})


export default router